import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { Services } from './components/Services';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
// Import EmailJS configuration
import './components/EmailjsConfig';
export function App() {
  useEffect(() => {
    // Reveal animations on scroll
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-10');
        }
      });
    }, {
      threshold: 0.1
    });
    document.querySelectorAll('.reveal').forEach(el => {
      el.classList.add('opacity-0', 'translate-y-10', 'transition-all', 'duration-700');
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  return <div className="font-sans bg-gradient-to-b from-[#171b31] to-[#1e2340] text-white overflow-hidden" data-id="element-0">
      <div className="fixed inset-0 z-0" data-id="element-1">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] gradient-circle opacity-20" data-id="element-2"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] gradient-circle opacity-20" data-id="element-3"></div>
        <div className="absolute top-1/2 left-1/3 w-[400px] h-[400px] gradient-circle opacity-10" data-id="element-4"></div>
        <div className="absolute h-screen w-screen hologram-grid opacity-20" data-id="element-5"></div>
      </div>
      <Navbar data-id="element-6" />
      <main className="relative z-10" data-id="element-7">
        <Hero data-id="element-8" />
        <AboutUs data-id="element-9" />
        <Services data-id="element-10" />
        <HowItWorks data-id="element-11" />
        <Testimonials data-id="element-12" />
        <ContactForm data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}